import React from 'react'
import { default as AccessLevelSelect } from '../AccessLevelSelect'
import { default as Option } from '../LevelOption'
import type { AccessLevelSelectProps, ParentAccessLevel } from '../types'

export const ParentPermissionsAccessSelect = ({
  level,
  setLevel,
  hideCommentLabel,
}: AccessLevelSelectProps<ParentAccessLevel, ParentAccessLevel>) => (
  <AccessLevelSelect
    level={level}
    setLevel={(value: ParentAccessLevel) => setLevel(value)}
    commentsEnabled={true}
    hideCommentLabel={hideCommentLabel}
  >
    <Option
      data-testid="access-level-dropdown-view"
      level="VIEW"
      label="View"
      help="View document in the web app"
    />
    <Option
      data-testid="access-level-dropdown-edit"
      level="DEFAULT"
      label="Default"
      help="Workspace Editors can edit and Viewers can inspect"
    />
  </AccessLevelSelect>
)
